//#region src/core/ui/captions-radio-group/data.ts
const CaptionsRadioGroupDataAttrs = {
	/** Present when captions are enabled. */
	subtitlesShowing: "data-active",
	/** Present when track selection is disabled. */
	disabled: "data-disabled",
	/** Present when track selection is unavailable. */
	hidden: "data-hidden",
	/** Indicates captions availability (`available` or `unavailable`). */
	availability: "data-availability"
};
//#endregion
export { CaptionsRadioGroupDataAttrs };

//# sourceMappingURL=data.js.map